<template lang='pug'>
  div.page-level
    h1 Straight Fire 🔥
    p Trolling the internet for the best burns
    p &nbsp;
    //- c(u='https://www.reddit.com/r/esist/comments/6s4rib/trumps_malignant_pattern_he_woos_people_rips_them/dla4boi/')
    //- c(u='https://www.reddit.com/r/politics/comments/6s1w4n/the_goldwater_rule_prevents_psychiatrists/dl9e9v8/')
    c(u='https://www.reddit.com/r/esist/comments/6rkj9n/hes_the_opposite_of_teddy_roosevelt_a_former/dl5y15w/')
    c(u='https://www.reddit.com/r/politics/comments/6qzwd7/trump_told_golf_club_members_that_the_white_house/dl19wvc/')
    c(u='https://www.reddit.com/r/politics/comments/6r5v2t/poll_trump_hits_new_low_at_33_percent_approval/dl2ip3q/')
    c(u='https://www.reddit.com/r/worldnews/comments/6c5ovz/nytimes_trump_told_russians_that_firing_nut_job/dhs50di/')
    c(u='https://www.reddit.com/r/worldnews/comments/6bv4f9/trump_campaign_had_at_least_18_undisclosed/dhprbfv/')
    //- c(u='https://www.reddit.com/r/politics/comments/6bvrue/reminder_anyone_who_supports_trump_is_a_traitor/dhpw7ey/')
    //- c(u='https://www.reddit.com/r/politics/comments/6bv47c/donald_trump_campaign_repeatedly_met_with_russia/dhpr1a8/')
    //- c(u='https://www.reddit.com/r/politics/comments/6bvrue/reminder_anyone_who_supports_trump_is_a_traitor/dhpvrh9/')
</template>

<script>
import RedditComment from './RedditComment'

export default {
  name: 'Burn',
  components: {
    'c': RedditComment
  }
}
</script>

<style lang='stylus'>
</style>



// WEBPACK FOOTER //
// Burn.vue?645fe3b4